import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgWallLockLawyersOnly(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M108.604 44.67H57.396a2.986 2.986 0 0 0-2.986 2.986v40.518a2.986 2.986 0 0 0 2.986 2.986h51.208a2.986 2.986 0 0 0 2.986-2.986V47.656a2.986 2.986 0 0 0-2.986-2.986Z"
        fill="#F1F5F9"
      />
      <path
        d="M57.023 44.67h51.955a2.615 2.615 0 0 1 2.612 2.613v2.605H54.41v-2.605a2.616 2.616 0 0 1 2.613-2.613Z"
        fill="#78B441"
      />
      <path
        d="M57.03 48.082a.8.8 0 1 0 0-1.598.8.8 0 0 0 0 1.598ZM60.21 48.082a.8.8 0 1 0 0-1.598.8.8 0 0 0 0 1.598ZM63.39 48.082a.8.8 0 1 0 0-1.598.8.8 0 0 0 0 1.598Z"
        fill="#599F40"
      />
      <path
        d="M59.412 74.798c0-.732.59-1.322 1.328-1.322h44.535a1.32 1.32 0 1 1 0 2.642H60.74c-.731 0-1.328-.589-1.328-1.32ZM59.412 79.56c0-.731.59-1.321 1.328-1.321h44.535a1.32 1.32 0 1 1 0 2.642H60.74c-.731 0-1.328-.59-1.328-1.32ZM59.412 84.323c0-.732.59-1.322 1.328-1.322h44.535a1.32 1.32 0 1 1 0 2.643H60.74c-.731 0-1.328-.59-1.328-1.321ZM59.412 57.599c0-.582.731-1.06 1.627-1.06h43.93c.896 0 1.627.47 1.627 1.06v10.585c0 .582-.731 1.06-1.627 1.06h-43.93c-.896 0-1.627-.47-1.627-1.06V57.599Z"
        fill="#E2E8F0"
      />
      <path
        d="M62.235 44.67H11.027a2.986 2.986 0 0 0-2.986 2.986v40.518a2.986 2.986 0 0 0 2.986 2.986h51.208a2.986 2.986 0 0 0 2.986-2.986V47.656a2.986 2.986 0 0 0-2.986-2.986Z"
        fill="#F1F5F9"
      />
      <path
        d="M10.653 44.67h51.955a2.616 2.616 0 0 1 2.613 2.613v2.605H8.04v-2.605a2.616 2.616 0 0 1 2.612-2.613Z"
        fill="#78B441"
      />
      <path
        d="M11.4 48.083a.8.8 0 1 0 0-1.599.8.8 0 0 0 0 1.599ZM14.58 48.082a.8.8 0 1 0 0-1.598.8.8 0 0 0 0 1.598ZM17.76 48.082a.8.8 0 1 0 0-1.598.8.8 0 0 0 0 1.598Z"
        fill="#599F40"
      />
      <path
        d="M13.042 74.798c0-.732.59-1.322 1.329-1.322h44.535a1.32 1.32 0 1 1 0 2.642H14.364c-.732 0-1.33-.589-1.33-1.32h.008ZM13.042 79.56c0-.731.59-1.321 1.329-1.321h44.535a1.32 1.32 0 1 1 0 2.642H14.364c-.732 0-1.33-.59-1.33-1.32h.008ZM13.042 84.323c0-.732.59-1.322 1.329-1.322h44.535a1.32 1.32 0 1 1 0 2.643H14.364c-.732 0-1.33-.59-1.33-1.321h.008ZM13.042 57.599c0-.582.732-1.06 1.628-1.06H58.6c.895 0 1.627.47 1.627 1.06v10.585c0 .582-.732 1.06-1.627 1.06H14.67c-.896 0-1.628-.47-1.628-1.06V57.599Z"
        fill="#E2E8F0"
      />
      <path
        d="M114.139 90.398a.8.8 0 0 1 0 1.6H5.5a.8.8 0 1 1 0-1.6h108.639ZM103.163 26.003a.8.8 0 0 1 1.053 1.205l-4.897 4.284a.8.8 0 1 1-1.053-1.204l4.897-4.285ZM104.057 33.804a.8.8 0 0 1 .506 1.518l-3.674 1.224a.8.8 0 1 1-.505-1.517l3.673-1.225ZM95.046 24.35a.8.8 0 0 1 1.372.823l-1.837 3.061a.8.8 0 1 1-1.37-.823l1.835-3.06Z"
        fill="#0F172A"
      />
      <path
        d="M92.052 33.72H27.586a2.986 2.986 0 0 0-2.985 2.985v51.29a2.986 2.986 0 0 0 2.986 2.986h64.465a2.986 2.986 0 0 0 2.986-2.986v-51.29a2.986 2.986 0 0 0-2.986-2.986Z"
        fill="#fff"
      />
      <path
        d="M27.587 33.72h64.465a2.985 2.985 0 0 1 2.986 2.985v3.441H24.6v-3.44a2.985 2.985 0 0 1 2.986-2.987Z"
        fill="#78B441"
      />
      <path d="M28.565 37.907a.978.978 0 1 0 0-1.956.978.978 0 0 0 0 1.956Z" fill="#599F40" />
      <path
        d="M23.8 87.249V76.686a.8.8 0 1 1 1.6 0V87.25a2.934 2.934 0 0 0 2.933 2.933h62.973a2.934 2.934 0 0 0 2.932-2.933V40.146a.8.8 0 1 1 1.6 0V87.25a4.534 4.534 0 0 1-4.532 4.532H28.333a4.533 4.533 0 0 1-4.532-4.532Z"
        fill="#0F172A"
      />
      <path
        d="M32.483 37.907a.978.978 0 1 0 0-1.956.978.978 0 0 0 0 1.956ZM36.402 37.907a.978.978 0 1 0 0-1.956.978.978 0 0 0 0 1.956Z"
        fill="#599F40"
      />
      <path
        d="M30.759 70.819c0-.903.732-1.627 1.635-1.627h54.85c.904 0 1.635.731 1.635 1.627s-.731 1.627-1.634 1.627H32.394a1.633 1.633 0 0 1-1.635-1.627ZM30.759 76.686c0-.903.732-1.627 1.635-1.627h54.85c.904 0 1.635.732 1.635 1.627 0 .896-.731 1.628-1.634 1.628H32.394a1.633 1.633 0 0 1-1.635-1.628ZM30.759 82.554c0-.904.732-1.628 1.635-1.628h54.85c.904 0 1.635.732 1.635 1.628 0 .895-.731 1.627-1.634 1.627H32.394a1.633 1.633 0 0 1-1.635-1.627Z"
        fill="#E2E8F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.722 61.705a1.921 1.921 0 0 1-.71-2.627l4.51-7.764a1.942 1.942 0 0 1 2.642-.702c.926.53 1.24 1.71.71 2.628l-4.51 7.764a1.941 1.941 0 0 1-2.642.701Z"
        fill="#FC0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.673 61.705a1.943 1.943 0 0 1-2.642-.701l-4.51-7.764a1.921 1.921 0 0 1 .71-2.628 1.943 1.943 0 0 1 2.642.702l4.51 7.764c.53.918.216 2.097-.71 2.627Z"
        fill="#378CC8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.79 51.187s-.021-.038-.036-.052a.797.797 0 0 0-.075-.09.377.377 0 0 0-.052-.06l-.068-.067-.067-.067a.376.376 0 0 1-.06-.052c-.03-.023-.06-.053-.089-.075-.015-.015-.037-.022-.06-.037l-.104-.068c-.023-.014-.045-.022-.067-.037-.038-.015-.068-.037-.105-.052l-.082-.038c-.03-.014-.06-.022-.09-.037s-.067-.022-.097-.03c-.022 0-.052-.015-.074-.022a2.54 2.54 0 0 1-.105-.022.264.264 0 0 1-.074-.015c-.038 0-.068-.008-.105-.015H37.022c-.038 0-.067 0-.105.015a.264.264 0 0 0-.074.015c-.038 0-.075.014-.105.022-.022 0-.052.015-.075.022-.03.008-.067.023-.097.03a.46.46 0 0 0-.09.038c-.029.014-.051.022-.081.037-.038.015-.067.037-.105.052-.022.015-.044.023-.067.037a1.25 1.25 0 0 0-.104.068c-.023.015-.038.022-.06.037-.03.022-.06.045-.09.075-.022.014-.037.03-.06.052a42.48 42.48 0 0 1-.067.067l-.067.067c-.015.023-.03.038-.052.06-.023.03-.052.06-.075.09-.015.014-.022.037-.037.052-.022.037-.045.067-.067.104a1.902 1.902 0 0 0-.008 1.941l1.672 2.882 1.672-2.882a1.938 1.938 0 0 0-.007-1.94c-.022-.038-.045-.068-.067-.105h-.015Z"
        fill="#78B441"
      />
      <path
        d="M51.003 49.641c0-.716.583-1.306 1.307-1.306h35.263c.724 0 1.306.582 1.306 1.306v13.034c0 .717-.582 1.306-1.306 1.306H52.31a1.303 1.303 0 0 1-1.307-1.306V49.64Z"
        fill="#E2E8F0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgWallLockLawyersOnly)
